// src/Community/CommentsSection.js
import React, { useState } from 'react';
import './CommentsSection.css';
import sendGreenIcon from '../Icons/sendgreen.png';

const CommentsSection = ({
  recipeId,
  comments,
  newComment,
  setNewComment,
  handleAddComment,
  handleEditComment,    // <- NUEVO
  handleDeleteComment,  // <- NUEVO
  userNames,
  currentUserId,        // <- NUEVO
  showAllComments,
  toggleComments
}) => {
  const [editingId, setEditingId]   = useState(null);
  const [editText, setEditText]     = useState('');

  const displayedComments = showAllComments
    ? comments[recipeId]
    : comments[recipeId]?.slice(-1);

  const startEdit = (comment) => {
    setEditingId(comment.id);
    setEditText(comment.text);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditText('');
  };

  const saveEdit = () => {
    if (editText.trim()) {
      handleEditComment(recipeId, editingId, editText);
      setEditingId(null);
      setEditText('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter')  saveEdit();
    if (e.key === 'Escape') cancelEdit();
  };

  return (
    <div className="comments-section">
      <div className="comment-input-wrapper">
        <input
          type="text"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleAddComment(recipeId)}
          placeholder="Agregar un comentario"
          className="comment-input"
        />
        <img
          src={sendGreenIcon}
          alt="Enviar"
          className="comment-send-icon"
          onClick={() => handleAddComment(recipeId)}
          title="Enviar comentario"
          style={{cursor: 'pointer'}}
        />
      </div>

      <div className="comments-container">
        {displayedComments && displayedComments.map(comment => (
          <div
            key={comment.id}
            className={`${showAllComments ? 'comment-full' : 'comment-preview'} ${currentUserId === comment.userId ? 'own-comment' : ''}`}
          >
            {editingId === comment.id ? (
              // --- Modo edición inline ---
              <div className="comment-edit-wrapper">
                <input
                  className="comment-edit-input"
                  value={editText}
                  onChange={e => setEditText(e.target.value)}
                  onKeyDown={handleKeyDown}
                  autoFocus
                />
                <button className="comment-action-btn save" onClick={saveEdit} title="Guardar">✓</button>
                <button className="comment-action-btn cancel" onClick={cancelEdit} title="Cancelar">✕</button>
              </div>
            ) : (
              // --- Modo lectura ---
              <>
                <span className="comment-user">{userNames[comment.userId] || comment.userId}: </span>
                <span className="comment-text">{comment.text}</span>
                {currentUserId === comment.userId && (
                  <span className="comment-owner-actions">
                    <button
                      className="comment-action-btn edit"
                      onClick={() => startEdit(comment)}
                      title="Editar comentario"
                    >✏️</button>
                    <button
                      className="comment-action-btn delete"
                      onClick={() => handleDeleteComment(recipeId, comment.id)}
                      title="Eliminar comentario"
                    >🗑️</button>
                  </span>
                )}
              </>
            )}
          </div>
        ))}
      </div>

      {comments[recipeId]?.length > 1 && !showAllComments && (
        <p className="view-more-comments" onClick={toggleComments}>Ver más comentarios</p>
      )}
      {showAllComments && (
        <p className="view-more-comments" onClick={toggleComments}>Ver menos comentarios</p>
      )}
    </div>
  );
};

export default CommentsSection;